import React from 'react';

const Tabnav = (props) => {
  return (
    <ul className={`innerNav ${props.navClass}`}>
      {props.data.map((curr, index) => {
        return (
          <li key={index} className="abc">
            <a className={`${props.active === curr.active ? "active" : ""}`} href={curr.url}>{curr.name}</a>
          </li>
        )
      })}
    </ul>
  )
}

export default Tabnav;